<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 889.33 398"
    :class="$b({gradient, explore})"
  >
    <defs>
      <linearGradient
        id="IconGradient-sungod-default"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(20)"
      ><stop
        offset="0%"
        stop-color="#5C0F99"
      /><stop
        offset="60%"
        stop-color="#3449B8"
      /><stop
        offset="100%"
        stop-color="#1799E1"
      />
      </linearGradient>
    </defs>
    <g>
      <path d="M571.27,136.64c1.89,3.17,4.98,4.75,10.22,4.75c13.3,0,23.91-8.97,26.96-23.42c3.68-17.47-2.19-32.98-13.78-43.32   c-11.24-10.02-27.79-14.64-48.19-14.64c-51.09,0-94.67,36.41-113.53,105.55c-6.08,22.28-7.98,41.96-6.47,58.82   c-5.6,9.5-10.55,15-17.6,20.26c-5.67,4.23-9.37,4.06-11.65,2.31c-1.73-1.32-2.38-4.22-1.58-10.77   c2.57-21.08,12.99-48.94,14.82-65.69c0.9-8.22-2.42-14.51-13.78-14.51c-19.19,0-32.16,12.15-55.34,53.16   c4.31-16.69,8.72-32.01,10.83-38.99c2.76-9.12-1.6-12.5-12.16-12.5c-11.54,0-17.37,4.54-21.78,19.31   c-3.58,12-10.66,42.44-12.54,50.86c-2.7,12.15-14.79,23.03-21.82,21.36c-3.35-0.79-4.42-4.37-4.03-11.11   c1.1-19.14,13.63-58.08,16.42-69.42c1.75-7.12-1.54-11-11.79-11c-11.67,0-18.31,3.9-23.66,19.14c-2.36,6.72-5.35,17.75-7.95,26.79   c-4.31,14.97-7.39,27.48-11.07,34.77c-4.17,8.25-8.95,11.5-12.49,10.83c-6.6-1.24-6.84-10.88,0.38-38.67   c4.2-16.17,10.19-34.84,11.92-41.86c1.73-7.05-1.36-11-11.92-11c-13.17,0-18.71,5.73-23.53,19.17   c-4.25,11.84-9.79,31.36-12.99,47.66c-3.75,19.13-3.83,32.96,0.31,42.53c4.14,9.56,12.33,14.26,22.22,14.26   c9.38,0,21.13-2.61,34-20.1c2.14,9.92,8.43,20.1,22.02,20.1c10.7,0,22.2-6.4,31.98-19.54c0.82,13.11,7.84,17.77,16.3,17.77   c6,0,10.63-2.49,13.51-10.3c2.16-5.87,5.17-12.93,8.4-19.7c8.2-17.19,19.44-35.02,29.8-48.19c-10.09,28.91-12.37,51.36-9.29,63.05   c2.72,10.33,10.18,16.92,22.18,16.92c10.58,0,22.68-6.16,34.65-17.37c4.51-4.22,8.91-8.95,12.83-14.06   c10.7,28.59,34.69,44.08,65.27,44.08c16.67,0,32.46-4.32,46.27-16.73c-7.99,32.39-15.05,61.55-20.09,81.88   c-1.85,7.47,2.09,12.7,13.26,12.7c16.58,0,21-9.46,23.29-18.66c4.4-17.73,27.19-110.85,36.08-146.45   c1.27-5.08,0.61-7.83-1.28-10.09c-1.82-2.18-5.66-3.42-10.82-3.42c-14.68,0-21.38,6.63-25.66,18.17c-0.32,0.86-1.68,4.13-1.98,4.99   c-11.57,32.4-33.27,46.1-52.61,46.1c-34.16,0-46.83-35.7-32.89-90.07c12.49-48.7,40.43-82.46,74.94-82.46   c20.84,0,32.58,13.96,26.04,33.94C569.85,129.99,569.46,133.6,571.27,136.64z" /><path d="M826.27,245c-7.07,6.33-11.75,6.16-14.19,4.66c-5.26-3.24-2.08-19.16,3.63-42.69c9.96-41.05,24.1-100.33,36.62-148.99   c1.31-5.08,1.12-8-0.7-10.17c-2.09-2.48-5.78-3.48-11.68-3.48c-7.14,0-11.79,1.6-15.72,5.52c-3.36,3.35-5.81,8.49-7.69,15.96   c-6.22,24.79-18.23,73.52-24.85,100.41c-6.32-7.66-15.68-11.28-26.14-11.28c-4,0-8.04,0.63-12,1.94c-0.25,0.07-0.49,0.14-0.7,0.22   c-0.26,0.1-0.52,0.2-0.78,0.3c-0.19,0.07-0.37,0.14-0.56,0.22c-19.02,7.43-32.1,19.48-50.22,21.9   c-5.68-15.74-18.51-24.49-36.56-24.49c-30.98,0-53.78,23.6-60.9,63.11c-7.12,39.49,9.05,63.1,38.14,63.1   c31.01,0,53.78-23.61,60.9-63.1c1.05-5.8,1.59-11.24,1.68-16.33c4.88-1.17,9.72-2.69,14.43-4.48c-2.05,5.8-3.73,12.12-5.16,19.71   c-8.12,43.17,11.44,64.2,34.1,64.2c11.03,0,24.23-5.11,33.7-18.45c3.35,13.08,11.82,18.28,21.97,18.28c11.15,0,20.91-5.5,27.7-12   c8.55-8.18,13.33-18.19,8.69-23.77C837.03,241.75,831.61,240.23,826.27,245z M670.44,217.15c-4.18,21.13-13.16,33.17-23.41,33.17   c-9.64,0-14.79-12.04-10.61-33.17c3.45-17.44,10.18-28.69,18.19-32.08c0.89,7.78,6.37,15.05,17.3,18.01   C671.94,207.18,671.48,211.88,670.44,217.15z M780.23,217.11c-4.12,20.78-13.01,33.24-23.51,33.24   c-10.13,0-14.57-12.78-10.51-33.24c4.19-21.14,13.18-33.2,23.43-33.2C779.28,183.91,784.42,195.96,780.23,217.11z" /><path d="M119.57,58.84c-41.17,0-69.17,21.47-78.35,47.47c-9.39,26.59-1.63,48.3,16.33,61.97c22.86,17.4,51.79,24.05,70.8,36.88   c11.96,8.07,18.33,20.11,13.06,35.68c-4.81,14.21-21.82,25.91-50.48,25.91c-40.5,0-59.07-24.4-45.82-49.94   c2.58-4.98,3.31-9.47,1.44-12.83c-2.06-3.71-6.28-5.17-11.03-5.17c-15.4,0-27.72,11.17-30.83,28.75   c-5.81,32.87,24.05,68.36,87.44,68.36c41.02,0,76.1-14.52,86.58-50.85c9.11-31.59-2.26-53.17-20.08-66.09   c-22.84-16.56-51.7-23.08-69.8-35.33c-11.63-7.88-17.08-18.41-11.97-32.01C82.11,97.64,98.44,88,117.69,88   c26.75,0,40.62,15.65,34.14,33.46c-2.38,6.55-3.31,10.35-2,13.51c1.3,3.16,4.36,5.92,10.52,5.92c12.08,0,22.96-7.42,26.78-21.09   C196.46,86.36,165.4,58.84,119.57,58.84z" />
      <path d="M869.74,246.95c-0.01,0-0.01,0-0.02,0c-4.73,0-9.21,1.91-12.63,5.36c-3.42,3.45-5.28,7.96-5.23,12.68   c0.08,9.18,7.44,16.37,16.74,16.38c0,0,0.01,0,0.01,0c4.81,0,9.31-1.88,12.68-5.28c3.36-3.39,5.17-7.89,5.12-12.66   C886.31,254.18,878.99,246.95,869.74,246.95z" />
    </g>
  </svg>
</template>
<script>
export default {
  name: 'BaseLogo',

  props: {
    gradient: {
      type: Boolean,
      default: false
    },
    explore: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="postcss">
.BaseLogo {
  @apply fill-off-black;
}

.BaseLogo--gradient {
  fill: url('#IconGradient-sungod-default');
}

.BaseLogo--explore {
  @apply fill-white;

  &:hover {
    fill: url('#IconGradient-sungod-default');
  }
}

</style>
